import React from "react";
import DataGrid, { Column, FilterRow } from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import ODataStore from "devextreme/data/odata/store";
import Button from "devextreme-react/button";
import { StoreErrorHandler } from "api/ApiClientBase";
import { getToken } from "api/ApiClientBase";

const source = new DataSource({
    store: new ODataStore({
        version: 4,
        url: "odata/v4/Delivery",
        key: "Id",
        // TODO: refactor errorHandler and beforeSend
        errorHandler: StoreErrorHandler,
        beforeSend: (request) => {
            request.headers["Authorization"] = `Bearer ${getToken()}`;
        },
    }),
});

export function Deliveries() {
    const dataGridRef = React.useRef<DataGrid>(null);

    const handleRefresh = () => {
        dataGridRef.current?.instance.refresh();
    };

    return (
        <>
            <Button icon="refresh" type="normal" onClick={handleRefresh} />
            <div></div>
            <DataGrid ref={dataGridRef} dataSource={source} hoverStateEnabled>
                <FilterRow visible={true} />
                <Column dataField="DPAInstanceId" />
                <Column dataField="Timestamp" dataType="datetime" sortOrder="desc" />
                <Column dataField="Transport" />
                <Column dataField="Contact" />
                <Column dataField="DeliveryStatus" />
                <Column dataField="DeliveryError" />
                <Column dataField="SendDuration" />
            </DataGrid>
        </>
    );
}
